// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type StyleFilename,
  StyleFilenameFromJSON,
  StyleFilenameToJSON,
} from "../models/StyleFilename";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface CreateFileDescriptorStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  files: Array<Blob>;
}

export interface CreatePublicationLayerStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  version: number;
  /**
   *
   */
  filePath: string;
  /**
   *
   */
  files: Array<Blob>;
}

export interface GetFileDescriptorStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  fileName: StyleFilename;
}

export interface GetStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  styleId: string;
  /**
   *
   */
  fileName: StyleFilename;
}

export interface PublicationGetStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  styleId: string;
  /**
   *
   */
  fileName: StyleFilename;
  /**
   *
   */
  version?: number | null;
}

/**
 *
 */
export class StylesApi extends runtime.BaseAPI {
  /**
   * Creates request options for createFileDescriptorStyle without sending the request
   */
  async createFileDescriptorStyleRequestOpts(
    requestParameters: CreateFileDescriptorStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling createFileDescriptorStyle().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling createFileDescriptorStyle().'
      );
    }

    if (requestParameters["files"] == null) {
      throw new runtime.RequiredError(
        "files",
        'Required parameter "files" was null or undefined when calling createFileDescriptorStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["files"] != null) {
      requestParameters["files"].forEach((element) => {
        formParams.append("files", element as any);
      });
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * Vector styling should conforming to the Maplibre style spec. See https://maplibre.org/maplibre-style-spec/, and can be set using a style.json. Optionally, sprite sheet files can be submitted as well. See https://maplibre.org/maplibre-style-spec/sprite/. Note that the style JSON file contains references to the vector data sources as possibly to the sprite files. These are not set by the backend and should be patched by the client. Before using the style JSON file.  Raster styling should conform to Lizard spec, and can be set using using a colormap.json file.
   * Upload style files for a file descriptor
   */
  async createFileDescriptorStyleRaw(
    requestParameters: CreateFileDescriptorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>> {
    const requestOptions = await this.createFileDescriptorStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Vector styling should conforming to the Maplibre style spec. See https://maplibre.org/maplibre-style-spec/, and can be set using a style.json. Optionally, sprite sheet files can be submitted as well. See https://maplibre.org/maplibre-style-spec/sprite/. Note that the style JSON file contains references to the vector data sources as possibly to the sprite files. These are not set by the backend and should be patched by the client. Before using the style JSON file.  Raster styling should conform to Lizard spec, and can be set using using a colormap.json file.
   * Upload style files for a file descriptor
   */
  async createFileDescriptorStyle(
    requestParameters: CreateFileDescriptorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string> {
    const response = await this.createFileDescriptorStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for createPublicationLayerStyle without sending the request
   */
  async createPublicationLayerStyleRequestOpts(
    requestParameters: CreatePublicationLayerStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling createPublicationLayerStyle().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling createPublicationLayerStyle().'
      );
    }

    if (requestParameters["version"] == null) {
      throw new runtime.RequiredError(
        "version",
        'Required parameter "version" was null or undefined when calling createPublicationLayerStyle().'
      );
    }

    if (requestParameters["filePath"] == null) {
      throw new runtime.RequiredError(
        "filePath",
        'Required parameter "filePath" was null or undefined when calling createPublicationLayerStyle().'
      );
    }

    if (requestParameters["files"] == null) {
      throw new runtime.RequiredError(
        "files",
        'Required parameter "files" was null or undefined when calling createPublicationLayerStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["filePath"] != null) {
      formParams.append("file_path", requestParameters["filePath"] as any);
    }

    if (requestParameters["files"] != null) {
      requestParameters["files"].forEach((element) => {
        formParams.append("files", element as any);
      });
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/version/{version}/styles`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{version}",
      encodeURIComponent(String(requestParameters["version"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * Vector styling should conforming to the Maplibre style spec. See https://maplibre.org/maplibre-style-spec/, and can be set using a style.json. Optionally, sprite sheet files can be submitted as well. See https://maplibre.org/maplibre-style-spec/sprite/. Note that the style JSON file contains references to the vector data sources as possibly to the sprite files. These are not set by the backend and should be patched by the client. Before using the style JSON file.  Raster styling should conform to Lizard spec, and can be set using using a colormap.json file.
   * Upload style files
   */
  async createPublicationLayerStyleRaw(
    requestParameters: CreatePublicationLayerStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>> {
    const requestOptions = await this.createPublicationLayerStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Vector styling should conforming to the Maplibre style spec. See https://maplibre.org/maplibre-style-spec/, and can be set using a style.json. Optionally, sprite sheet files can be submitted as well. See https://maplibre.org/maplibre-style-spec/sprite/. Note that the style JSON file contains references to the vector data sources as possibly to the sprite files. These are not set by the backend and should be patched by the client. Before using the style JSON file.  Raster styling should conform to Lizard spec, and can be set using using a colormap.json file.
   * Upload style files
   */
  async createPublicationLayerStyle(
    requestParameters: CreatePublicationLayerStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string> {
    const response = await this.createPublicationLayerStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for getFileDescriptorStyle without sending the request
   */
  async getFileDescriptorStyleRequestOpts(
    requestParameters: GetFileDescriptorStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling getFileDescriptorStyle().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling getFileDescriptorStyle().'
      );
    }

    if (requestParameters["fileName"] == null) {
      throw new runtime.RequiredError(
        "fileName",
        'Required parameter "fileName" was null or undefined when calling getFileDescriptorStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{file_name}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{file_name}",
      encodeURIComponent(String(requestParameters["fileName"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * This endpoint is used for retrieving the default style of a file descriptor. If a style_id is known already, use get_style instead.
   */
  async getFileDescriptorStyleRaw(
    requestParameters: GetFileDescriptorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.getFileDescriptorStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * This endpoint is used for retrieving the default style of a file descriptor. If a style_id is known already, use get_style instead.
   */
  async getFileDescriptorStyle(
    requestParameters: GetFileDescriptorStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.getFileDescriptorStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for getStyle without sending the request
   */
  async getStyleRequestOpts(requestParameters: GetStyleRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling getStyle().'
      );
    }

    if (requestParameters["styleId"] == null) {
      throw new runtime.RequiredError(
        "styleId",
        'Required parameter "styleId" was null or undefined when calling getStyle().'
      );
    }

    if (requestParameters["fileName"] == null) {
      throw new runtime.RequiredError(
        "fileName",
        'Required parameter "fileName" was null or undefined when calling getStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/styles/{style_id}/{file_name}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{style_id}",
      encodeURIComponent(String(requestParameters["styleId"]))
    );
    urlPath = urlPath.replace(
      "{file_name}",
      encodeURIComponent(String(requestParameters["fileName"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve a style file by style id. Requires only tenant-level read access.
   * retrieve style or sprite files by style id
   */
  async getStyleRaw(
    requestParameters: GetStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.getStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Retrieve a style file by style id. Requires only tenant-level read access.
   * retrieve style or sprite files by style id
   */
  async getStyle(
    requestParameters: GetStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.getStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for listFeatureTypeStyles without sending the request
   */
  async listFeatureTypeStylesRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/feature-type-styles`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Get the mapping from feature type definition to style ID
   */
  async listFeatureTypeStylesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: { [key: string]: string | null } }>> {
    const requestOptions = await this.listFeatureTypeStylesRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Get the mapping from feature type definition to style ID
   */
  async listFeatureTypeStyles(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: { [key: string]: string | null } }> {
    const response = await this.listFeatureTypeStylesRaw(initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for listPhysicalQuantityStyles without sending the request
   */
  async listPhysicalQuantityStylesRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/physical-quantity-styles`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Get the mapping from physical quantity name to style ID and optional min/max
   */
  async listPhysicalQuantityStylesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any | null }>> {
    const requestOptions = await this.listPhysicalQuantityStylesRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Get the mapping from physical quantity name to style ID and optional min/max
   */
  async listPhysicalQuantityStyles(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any | null }> {
    const response = await this.listPhysicalQuantityStylesRaw(initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationGetStyle without sending the request
   * @deprecated
   */
  async publicationGetStyleRequestOpts(
    requestParameters: PublicationGetStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationGetStyle().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationGetStyle().'
      );
    }

    if (requestParameters["styleId"] == null) {
      throw new runtime.RequiredError(
        "styleId",
        'Required parameter "styleId" was null or undefined when calling publicationGetStyle().'
      );
    }

    if (requestParameters["fileName"] == null) {
      throw new runtime.RequiredError(
        "fileName",
        'Required parameter "fileName" was null or undefined when calling publicationGetStyle().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["version"] != null) {
      queryParameters["version"] = requestParameters["version"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/styles/{style_id}/{file_name}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{style_id}",
      encodeURIComponent(String(requestParameters["styleId"]))
    );
    urlPath = urlPath.replace(
      "{file_name}",
      encodeURIComponent(String(requestParameters["fileName"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve the style file for a style in a publication. When no version is given, the published version is used. Providing a version to access an unpublished publication version is not allowed for share key users.
   * This endpoint is deprecated: use \'get_style\' instead.
   * @deprecated
   */
  async publicationGetStyleRaw(
    requestParameters: PublicationGetStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.publicationGetStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Retrieve the style file for a style in a publication. When no version is given, the published version is used. Providing a version to access an unpublished publication version is not allowed for share key users.
   * This endpoint is deprecated: use \'get_style\' instead.
   * @deprecated
   */
  async publicationGetStyle(
    requestParameters: PublicationGetStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.publicationGetStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for uploadPhysicalQuantityStylesToLizard without sending the request
   */
  async uploadPhysicalQuantityStylesToLizardRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/migrations/physical-quantity-styles-to-lizard`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Uploads all physical quantity colormap definitions from local static files to Lizard as named colormaps (``RANA_STYLE__<id>``).  Uses content-addressed IDs so uploading the same colormap twice is a no-op.  Run this after deploying a new release that adds or changes physical quantity colormaps, or whenever the Lizard colormaps need to be brought back in sync with the local files.
   * Upload physical quantity colormaps to Lizard
   */
  async uploadPhysicalQuantityStylesToLizardRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<number>> {
    const requestOptions = await this.uploadPhysicalQuantityStylesToLizardRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<number>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Uploads all physical quantity colormap definitions from local static files to Lizard as named colormaps (``RANA_STYLE__<id>``).  Uses content-addressed IDs so uploading the same colormap twice is a no-op.  Run this after deploying a new release that adds or changes physical quantity colormaps, or whenever the Lizard colormaps need to be brought back in sync with the local files.
   * Upload physical quantity colormaps to Lizard
   */
  async uploadPhysicalQuantityStylesToLizard(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<number> {
    const response = await this.uploadPhysicalQuantityStylesToLizardRaw(initOverrides);
    return await response.value();
  }
}
